import { getServiceLink } from './mediaLinks'

export const getServiceLinks = (item, type) => {
  const links = []

  // Get all service links for the item
  const serviceLinks = getServiceLink(item, type)
  if (!serviceLinks) return null

  // Create links for each service
  for (const { service_name, url } of serviceLinks) {
    const serviceName =
      service_name === 'apple_music'
        ? 'Apple Music'
        : service_name.charAt(0).toUpperCase() + service_name.slice(1)
    links.push(
      <a
        key={`${service_name}-${url}`}
        href={url}
        target='_blank'
        rel='noopener noreferrer'
        className='service-link'
      >
        {serviceName}
      </a>
    )
  }

  return links.length > 0 ? links : null
}

export const renderServiceLinksWithSeparators = (links) => {
  if (!links || links.length === 0) {
    return <span className='metadata-text secondary'>No links available</span>
  }

  return links.reduce(
    (prev, curr, idx) =>
      idx === 0
        ? [curr]
        : [
            ...prev,
            <span key={`separator-${idx}`} className='separator'>
              {' '}
              •{' '}
            </span>,
            curr,
          ],
    []
  )
}
